"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapToConcernFormData = void 0;
const mapToConcernFormData = (param)=>{
    let { componentsLabels, validationLabels, ...rest } = param;
    var _rest_introduction, _rest_introduction1;
    var _componentsLabels_radioButtonNo;
    const radioButtonNo = (_componentsLabels_radioButtonNo = componentsLabels === null || componentsLabels === void 0 ? void 0 : componentsLabels.radioButtonNo) !== null && _componentsLabels_radioButtonNo !== void 0 ? _componentsLabels_radioButtonNo : '';
    var _componentsLabels_radioButtonYes;
    const radioButtonYes = (_componentsLabels_radioButtonYes = componentsLabels === null || componentsLabels === void 0 ? void 0 : componentsLabels.radioButtonYes) !== null && _componentsLabels_radioButtonYes !== void 0 ? _componentsLabels_radioButtonYes : '';
    var _componentsLabels_sendButton;
    const sendButton = (_componentsLabels_sendButton = componentsLabels === null || componentsLabels === void 0 ? void 0 : componentsLabels.sendButton) !== null && _componentsLabels_sendButton !== void 0 ? _componentsLabels_sendButton : '';
    var _validationLabels_questionRequired;
    const questionRequired = (_validationLabels_questionRequired = validationLabels === null || validationLabels === void 0 ? void 0 : validationLabels.questionRequired) !== null && _validationLabels_questionRequired !== void 0 ? _validationLabels_questionRequired : '';
    var _validationLabels_required;
    const required = (_validationLabels_required = validationLabels === null || validationLabels === void 0 ? void 0 : validationLabels.required) !== null && _validationLabels_required !== void 0 ? _validationLabels_required : '';
    var _validationLabels_tooManyCharactersMaximumIs;
    const tooManyCharactersMaximumIs = (_validationLabels_tooManyCharactersMaximumIs = validationLabels === null || validationLabels === void 0 ? void 0 : validationLabels.tooManyCharactersMaximumIs) !== null && _validationLabels_tooManyCharactersMaximumIs !== void 0 ? _validationLabels_tooManyCharactersMaximumIs : '';
    var _rest_introduction_text;
    const introduction = (_rest_introduction_text = (_rest_introduction = rest.introduction) === null || _rest_introduction === void 0 ? void 0 : _rest_introduction.text) !== null && _rest_introduction_text !== void 0 ? _rest_introduction_text : '';
    var _rest_introduction_title;
    const introductionTitle = (_rest_introduction_title = (_rest_introduction1 = rest.introduction) === null || _rest_introduction1 === void 0 ? void 0 : _rest_introduction1.title) !== null && _rest_introduction_title !== void 0 ? _rest_introduction_title : '';
    const questions = rest.questions.map((param)=>{
        let { title } = param;
        return title;
    }).filter((title)=>title !== undefined);
    return {
        introductionTitle,
        introduction,
        questions,
        questionRequired,
        radioButtonYes,
        radioButtonNo,
        required,
        sendButton,
        tooManyCharactersMaximumIs
    };
};
exports.mapToConcernFormData = mapToConcernFormData;
